export const validate = values => {
  const required = 'Required';

  const errors = {};
  if (!values.message) {
    errors.message = required
  }

  return errors
};